import type { BaseController } from '@infra/controllers/base.controller';
import type { BusAgentListPayload } from '@main/event-listeners/payloads/bus-agent-list.payload';
import type { StoreAgentListUsecase } from './store-agentlist.usecase';

export type StoreAgentListOutput = void;

export class StoreAgentListController
  implements BaseController<BusAgentListPayload, StoreAgentListOutput>
{
  constructor(private usecase: StoreAgentListUsecase) {}

  async handle(payload: BusAgentListPayload): Promise<StoreAgentListOutput> {
    if (payload.lookupTeammates.items.length > 0) {
      await this.usecase.run(payload);
    }
  }
}
